import { useEffect, useState } from "react";
import { GenUIComponentNotSupported } from "./GenUIComponentNotSupported";
import { genUIInputAreaStyles as s, genUIInputContainer } from "./GenUIInputArea.styles";
import { useGenUIInput } from "./GenUIInputContext";
import { genUIInputRegistry } from "./inputRegistry";
import type { ActiveInputComponent } from "../transport";

/**
 * Renders the active interactive GenUI component at the top of the composer card (not
 * in the scrollable message list). Mounts a fresh animated panel per component so each
 * one fades and slides in.
 */
export function GenUIInputArea() {
  const { activeInput } = useGenUIInput();
  if (!activeInput) return null;
  return <InputPanel key={activeInput.componentId} input={activeInput} />;
}

function InputPanel({ input }: { input: ActiveInputComponent }) {
  const [expanded, setExpanded] = useState(false);

  // Start collapsed, then expand on the next frame so the transition runs.
  useEffect(() => {
    const id = requestAnimationFrame(() => setExpanded(true));
    return () => cancelAnimationFrame(id);
  }, []);

  const renderer = genUIInputRegistry[input.component];

  return (
    <div className={genUIInputContainer({ expanded })}>
      <div className={s.inner}>
        {renderer ? (
          renderer(input.props)
        ) : (
          <GenUIComponentNotSupported component={input.component} />
        )}
      </div>
    </div>
  );
}
